<div class="user-files-list">
  <!-- Search and Filters Row (embedded within user detail view) -->
  <div *ngIf="!isLoading && file_data.documents.length > 0" 
       class="flex-row flex-center-y" 
       style="gap: 10px; margin-bottom: 16px;" >
    <input
      type="text"
      placeholder="Search files"
      [(ngModel)]="search_query"
      (keyup.enter)="onSearch()"
      style="flex: 1; border: 1px solid #e2e2e2; padding: 6px 10px; border-radius: 4px;"
    />
    <button (click)="onSearch()"
            class="btn btn-secondary" >Search</button>
    <div class="filter-control" 
         style="position: relative;">
      <button (click)="toggleFilters()"
              class="btn" >
        Filters<span *ngIf="sumOfFilterLength()"> ({{ sumOfFilterLength() }})</span>
      </button>
      <file-filter *ngIf="show_filters"
                   (filter_selelected_type)="onFilterTypeChange($event)"
                   (filter_cleared_type)="onFilterTypeClear()"
                   [active_filter_types]="filter_fileType">
      </file-filter>
    </div>
    <div *ngIf="search_is_active" class="clear-search" (click)="clearSearch()">
      Clear
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-indicator">
    <loading message="retrieving files..."></loading>
  </div>

  <!-- Files List -->
  <div *ngIf="!isLoading && file_data.documents.length > 0" class="file-list">
    <saffron-list-item
      *ngFor="let file of file_data.documents"
      [file]="file"
      [showActions]="false"
      (selected)="openFileSidebar($event)"
      (fileDeleted)="refreshFileList()">
    </saffron-list-item>

    <!-- Pagination footer -->
    <div class="pagination-footer flex-row flex-center-y flex-space-between" style="margin-top: 16px;">
      <div class="pagination-info">
        <p>
          Showing {{ showingFrom }}–{{ showingTo }} of {{ totalItems }}
        </p>
      </div>
      <div class="pagination-controls flex-row flex-center-y">
        <button class="btn btn-secondary btn-small" 
                (click)="firstPage()" 
                [disabled]="currentPage === 1">
                  « First
        </button>
        <button class="btn btn-secondary btn-small" 
                (click)="prevPage()" 
                [disabled]="currentPage === 1" 
                style="margin-left: 6px;">
                  ‹ Prev
        </button>
        <span style="margin: 0 10px;">Page {{ currentPage }} of {{ totalPages }}</span>
        <button class="btn btn-secondary btn-small" 
                (click)="nextPage()" 
                [disabled]="currentPage === totalPages || totalPages === 0" 
                style="margin-right: 6px;">
                  Next ›
        </button>
        <button class="btn btn-secondary btn-small" 
                (click)="lastPage()" 
                [disabled]="currentPage === totalPages || totalPages === 0">
                  Last »
        </button>
        <div style="margin-left: 16px;" class="page-size">
          <label for="pageSize" style="margin-right: 6px;">Per page</label>
          <select id="pageSize" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && file_data.documents.length === 0" class="empty-state">
    <img src="assets/nothing-here-2.svg" alt="No files" style="width: 220px; max-width: 80%; opacity: 0.9;" />
    <p class="empty-message" style="margin-top: 10px;">No files found for this user</p>
  </div>

  <!-- File Sidebar (reuse folders view component) -->
  <app-file-sidebar 
    [fileId]="selectedFileId" 
    [isOpen]="isSidebarOpen" 
    (close)="closeSidebar()">
  </app-file-sidebar>
</div>
